module.exports = __webpack_public_path__ + "static/media/Nursery_4.1af1415e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_4.png
// module id = 1283
// module chunks = 3